import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
interface TransactionInstallmentFieldProps {
  value: number;
  onChange: (value: number) => void;
  error?: string;
  disabled?: boolean;
  amount: number;
}
export const TransactionInstallmentField = ({
  value,
  onChange,
  error,
  disabled,
  amount
}: TransactionInstallmentFieldProps) => {
  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value);
  };
  const installmentOptions = Array.from({
    length: 24
  }, (_, i) => i + 1);
  const installmentValue = amount > 0 && value > 0 ? amount / value : 0;
  return <div className="space-y-2">
      <Label htmlFor="installments">Número de parcelas</Label>
      <Select value={value.toString()} onValueChange={val => onChange(parseInt(val))} disabled={disabled}>
        <SelectTrigger className={`rounded-xl ${error ? 'border-destructive' : ''}`}>
          <SelectValue placeholder="Selecionar parcelas" />
        </SelectTrigger>
        <SelectContent>
          {installmentOptions.map(num => <SelectItem key={num} value={num.toString()}>
              {num}x - {formatCurrency(amount / num)}
            </SelectItem>)}
        </SelectContent>
      </Select>
      {error && <p className="text-sm text-destructive">{error}</p>}
      {value > 1 && amount > 0 && <div className="text-sm text-muted-foreground">
          <p>Valor por parcela: {formatCurrency(installmentValue)}</p>
          
        </div>}
    </div>;
};